import PrivateNetworkClient from "helpers/privateNetwork";

const getAlertlist = async (formData) => {
  const { data } = await PrivateNetworkClient.get("/private/alert_emails", formData);
  return data;
};

const addAlertList = async (formData) => {
  const { data } = await PrivateNetworkClient.put("/private/alert_edit_email", formData);
  return data;
};

const getBeaconList = async (formData) => {
  if(localStorage.getItem('token') === null) {
    return null;
  }
  const { data } = await PrivateNetworkClient.post("/getTagList", formData);
  return data;
};

const addBeacon = async (formData) => {
  const { data } = await PrivateNetworkClient.post("/addTag", formData);
  return data;
};

const editBeacon = async (formData) => {
  const { data } = await PrivateNetworkClient.put("/editTag", formData);
  return data;
};

const deleteBeacon = async (id) => {
  const { data } = await PrivateNetworkClient.delete(`/deleteTag/${id}`);
  return data;
};

const statusTag = async (id) => {
  const { data } = await PrivateNetworkClient.put(`/tag/changeStatus/${id}`);
  return data;
}

export {
  getAlertlist,
  addAlertList,
  getBeaconList,
  addBeacon,
  editBeacon,
  deleteBeacon,
  statusTag
};
